import React from 'react';
import { STYLES } from '@/styles';

interface ButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  variant?: 'primary' | 'outline' | 'filled' | 'danger';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  className = '',
  type = 'button',
}) => {
  const variantStyles = {
    primary: STYLES.primaryButton,
    outline: STYLES.outlineButton,
    danger: STYLES.dangerButton,
    filled: '',
  };

  const sizeStyles = {
    small: STYLES.smallButton,
    medium: STYLES.mediumButton,
    large: STYLES.largeButton,
  };

  const disabledStyles = disabled ? STYLES.disabledButton : 'cursor-pointer';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${variantStyles[variant]} ${sizeStyles[size]} ${disabledStyles} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
